import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import TG from "../../../assets/images/tg.png"
import Twitter from "../../../assets/images/twitter.png"
import Eth from "../../../assets/images/eth.png"
import Dex from "../../../assets/images/dex.png"

import up from "../../../assets/images/secondbg.png"
const GridImage = styled(Grid)`
/* text-align: left; */
`;
const JOiningLinks = styled.img`
  width: 100%;
  height:auto;
  max-width: ${(props) => (props.mw ? props.mw : "400PX")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const FeatureWrapper = styled.div`
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`

const TgImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 170px;
`;
const BuyNow = styled.a`
text-decoration: none;
/* display:flex;
align-items:center; */
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textPrimary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 15px;
font-size:20px;
padding: 20px 30px 0;
margin-right: 15px;
font-family:"G-B";
border:1px solid #fff;
@media screen and (max-width:1009px){
  /* padding: 8px 37px; */
}
@media screen and (max-width:499px){
  font-size:15px;
  /* padding: 8px 20px; */
}
@media screen and (max-width:399px){
  /* padding: 8px 12px; */
}
`

const Div = styled.div`
  /* min-height: 100vh; */
  background-image: url(${up});
  background-size: cover;
  background-position: center center;
`;
const Flex = styled.div`
display: flex;
align-items: center;
gap: 20px;
justify-content: center;
padding: 30px 0;
`;
const Tg = styled.img`
width: 100%;
height: auto;
max-width: 60px;
`;
const S2_Aboutus = () => {
  return (
    <Div>
      <SectionWrapper p="4rem 0" id="about" >
        <Container maxWidth="xl">
          <Grid container justifyContent="center">

            <GridImage item xs={12} md={6} lg={7}>
              <SectionSubHeading
                align="center"
                p599="30PX 0"
                p="0"
                m="0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >About the token
              </SectionSubHeading>

              <P
                align="center"
                p="20px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
                In the world of cryptocurrency, a notorious figure named Carlos, infamous for the Bitconnect scam, is making a comeback with a new face and a mission to prove that even the biggest scammers deserve a second chance. Joining forces with severussnape , Clinton, and Zelda, they unveil SeverusSnapeClintonCarlosLink1000XInu, a token claiming to possess a profound store of value. With audacious presentations and charismatic speeches, they captivate audiences, blurring the line between redemption and deceit. Skeptics question their motives, wary of their past misdeeds. As the world watches, the fate of their venture hangs in the balance, as they strive to rewrite their narrative and leave their mark on the world of cryptocurrency.  <br />
              </P>
              <Flex>
                <a href="https://t.me/bitconnect_eth" target="blank">
                  <Tg src={TG} />
                </a>
                <a href="https://twitter.com/bitconnect_eth" target="blank">
                  <Tg src={Twitter} />
                </a>
                <a href="https://etherscan.io/token/0x02570673510011c8bb49d7dafd03ed7d0605648d" target="blank">
                <Tg src={Eth} />
                </a>
                <a href="https://www.dextools.io/app/en/ether/pair-explorer/0xd2e18cac18a54058b1b8e0b7b81e1fb9e620dad4" target="blank">
                <Tg src={Dex} />
                </a>
              </Flex>
            </GridImage>

          </Grid>
        </Container>
      </SectionWrapper>
    </Div>
  );
};

export default S2_Aboutus;
